import { ScheduleItem } from './types';

export const WEDDING_DATE = new Date('2026-06-13T14:00:00');
export const VENUE_NAME = "Enterkine Country House Resort";
export const VENUE_LOCATION = "Annbank, Ayr, KA6 5AL, Scotland";

export const SCHEDULE: ScheduleItem[] = [
  { 
    time: "1:30 PM", 
    event: "Guests Arrive", 
    description: "Welcome to Enterkine House." 
  },
  { 
    time: "2:00 PM", 
    event: "The Ceremony", 
    description: "Join us as we exchange our vows and become Mr & Mrs." 
  },
  { 
    time: "2:30 PM", 
    event: "Canapés & Drinks", 
    description: "Celebrate our first moments as a married couple with drinks and music." 
  },
  { 
    time: "4:30 PM", 
    event: "Speeches", 
    description: "A few words from our loved ones before dinner." 
  },
  { 
    time: "5:00 PM", 
    event: "The Wedding Meal", 
    description: "Time to enjoy a delicious dinner together." 
  },
  { 
    time: "7:00 PM", 
    event: "Evening Guests Arrive", 
    description: "Welcome to our evening guests! The party is just getting started." 
  },
  { 
    time: "7:30 PM", 
    event: "First Dance", 
    description: "Join us on the dance floor for our first dance as a married couple." 
  },
  { 
    time: "12:00 AM", 
    event: "Farewells", 
    description: "A final dance and farewells as the celebrations come to a close." 
  }
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1515934751635-c81c6bc9a2d8?auto=format&fit=crop&q=80&w=2000",
  venue: "https://image.bridebook.com/weddingsuppliers/venue/ee5gPvle8z/dc769370-582e-456f-831d-a20a6f6717f3.jpg/dpr=1,fit=cover,g=face,w=1500,h=1000",
  couple1: "https://images.unsplash.com/photo-1583939003579-730e3918a45a?auto=format&fit=crop&q=80&w=800",
  couple2: "https://images.unsplash.com/photo-1621619856624-42fd193a0661?auto=format&fit=crop&q=80&w=800",
  countdown: "https://files.catbox.moe/7c8dku.jpg"
};